import React, { useMemo, useContext } from 'react';
import { getLocale } from 'umi';
import { formatSmallValue, getChartDateFormatString, } from '@/pages/dashboard/utils/utils';
import { barFormatterFunc, yAxisFormat } from '@/pages/dashboard/components/Chart/_config/utils';
import { FilterContext } from '@/pages/dashboard/components/PageContainer/context';
import Revenue from '../../../components/Revenue';
import { usePCRevenueColumns } from '../PcRevenue';


function PcRevenueMetricsTrends(props: any) {
  const contextObj = useContext(FilterContext);
  const { data: defaultData = [], enName, cnName, defaultActive = 1, config: configs } = props;
  
  const { chart: { type, decimal }, componentMetricsConfig } = configs;
  const { filterVal: formValue } = contextObj || {};
  const { data: dataSource, loading, errorMsg } = defaultData?.PcMonetizationRevenueData || {};
  const data = dataSource?.mtx_arpu_and_arppu;
  const { timeType = 'Day' } = formValue;
  const {
    tableOption,
    chart,
    tableData,
    downloadData
  } = usePCRevenueColumns(data, componentMetricsConfig, timeType);
  const revenueData = useMemo(() => data ?? [], [data]);

  const config = {
    bar: {
      formatterFunc: (params: any[]) => barFormatterFunc(params, { type, decimal }),
      setOtherConfigFunc: (opt: {
        xAxis: { axisLabel: { formatter: (value: any) => any; }; }[]; series: any[]; yAxis: ({ type: string; position: string; splitLine: { show: boolean; lineStyle: { type: string; color: string; }; }; axisLabel: { color: string; fontSize: number; formatter: (value: any) => any; }; alignTicks?: undefined; } | {
          type: string; position: string; alignTicks: boolean; // 多Y轴时，开启是否对齐刻度线
          splitLine: { show: boolean; lineStyle: { type: string; color: string; }; }; axisLabel: { formatter: (value: any) => string | number; color?: undefined; fontSize?: undefined; };
        })[];
      }) => {
        opt.xAxis[0].axisLabel.formatter = (value: any) => (getChartDateFormatString(timeType, value));
        opt.series = opt.series?.map((item: any, index: any) => ({
          ...item,
          yAxisIndex: index,
        }));
        opt.yAxis = [
          {
            type: 'value',
            position: 'left',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#ddd',
              },
            },
            axisLabel: {
              color: '#888888',
              fontSize: 12,
              formatter: (value: any) => formatSmallValue(value, 'decimals', 2),
            },
          },
          {
            type: 'value',
            position: 'right',
            alignTicks: true, // 多Y轴时，开启是否对齐刻度线
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#ddd',
              },
            },
            axisLabel: {
              formatter: (value: number) => yAxisFormat(value)
            },
          },
        ];
        return opt;
      },
    },
    line: {
      formatterFunc: (params: any[]) => barFormatterFunc(params,  { type, decimal }),
      setOtherConfigFunc: (opt: {
        xAxis: { axisLabel: { formatter: (value: any) => any; }; }[]; series: any[]; yAxis: ({ type: string; position: string; splitLine: { show: boolean; lineStyle: { type: string; color: string; }; }; axisLabel: { color: string; fontSize: number; formatter: (value: any) => any; }; alignTicks?: undefined; } | {
          type: string; position: string; alignTicks: boolean; // 多Y轴时，开启是否对齐刻度线
          splitLine: { show: boolean; lineStyle: { type: string; color: string; }; }; axisLabel: { formatter: (value: any) => string | number; color?: undefined; fontSize?: undefined; };
        })[];
      }) => {
        opt.xAxis[0].axisLabel.formatter = (value: any) => (getChartDateFormatString(timeType, value));
        opt.series = opt.series?.map((item: any, index: any) => ({
          ...item,
          stack: '',
          showSymbol: true,
          yAxisIndex: index,
        }));
        opt.yAxis = [
          {
            type: 'value',
            position: 'left',
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#ddd',
              },
            },
            axisLabel: {
              color: '#888888',
              fontSize: 12,
              formatter: (value: any) => formatSmallValue(value, 'decimals', 2),
            },
          },
          {
            type: 'value',
            position: 'right',
            alignTicks: true, // 多Y轴时，开启是否对齐刻度线
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed',
                color: '#ddd',
              },
            },
            axisLabel: {
              formatter: (value: number) => yAxisFormat(value),
            },
          },
        ];
        return opt;
      },
    },
  };
  const options = useMemo(() => ({
    chart,
    table: {
      option: tableOption,
      data: tableData,
      downloadData,
    },
  }), [revenueData, getLocale()]);

  return (
    <Revenue {...{
      otherOption: options,
      data: {
        MonetizationRevenueData: {
          data: {
            revenue: revenueData
          },
          loading,
          errorMsg
        }
      },
      enName,
      cnName,
      renderFormatterFunc: (params: any) => {
        const result = formatSmallValue(params.value, type, decimal);
        return result;
      },
      otherConfig: config,
      defaultActive,
      isShowLegend: true
    }} />
  );
}

export default PcRevenueMetricsTrends;
